<script setup lang="ts">
import type { CentlexLinkableText } from "@/types/article-formats/centlex";

import ArticleLink from "./ArticleLink.vue";
import ArticleSection from "./ArticleSection.vue";

const props = defineProps<{
  label: string;
  list: CentlexLinkableText[];
}>();
</script>

<template>
  <ArticleSection :label="props.label" class="article-content__inline-list">
    <span v-for="(item, index) in props.list" :key="index">
      <ArticleLink
        v-if="item.isLink"
        :query="item.text"
        class="article-content__text article-content__text--link"
      />
      <span v-else class="article-content__text article-content__text--secondary">
        {{ item.text }}
      </span>
    </span>
  </ArticleSection>
</template>
